import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../../axiosAuth";
import { UPDATE_KIT } from "../apiRoutes";

const mutateUpdate = async ({ id,data }: { id:string; data: FieldValues }) => {
  return await axiosAuth.put(`${UPDATE_KIT}${id}`, data);
};

const useUpdateKitMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      id: string;
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateUpdate,
    ...queryParams,
  });

export default useUpdateKitMutation;
